
export const getFileTypeFromUrl = (url) => {
  const parts = url?.split('.') || [];
  const extension = parts[parts.length - 1];
  switch (extension) {
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
      return 'image';
    case 'mp3':
      return 'audio';
    case 'mp4':
    case 'avi':
    case 'mov':
      return 'video';
    default:
      return null;
  }
}